import { useEffect, useState } from 'react'

import { Shop } from '@/features/product/choose-pickup-point/types/shop'

import { Notification } from '@/shared/ui/Notification'
import { SegmentedControl } from '@/shared/ui/segmented-control'

import { usePickup } from '../../hooks/usePickup'
import { ShopsList } from '../ShopsList/ShopsList'
import { ShopsMap } from '../ShopsMap/ShopsMap'

import cl from './Pickup.module.scss'

type ShopsView = 'map' | 'list'

const pickupViewOptions = [
	{ label: 'Карта', value: 'map' },
	{ label: 'Список', value: 'list' }
]

interface PickupProps {
	className?: string
	shops?: Shop[]
	inProduct?: boolean
	isShops?: boolean
}

export const Pickup = (props: PickupProps) => {
	const { className, shops, inProduct } = props

	const { selectedShop, handleShopSelection, resetSelection } = usePickup({
		onSubmition: () => {},
		shops
	})

	const [selectedView, setSelectedView] = useState<ShopsView>('map')

	const showList = selectedView === 'list'
	const showMap = selectedView === 'map'

	const handleViewChange = (value: ShopsView) => {
		setSelectedView(value)
	}

	useEffect(() => {
		return () => {
			resetSelection()
		}
	}, [])

	return (
		<div className={className}>
			<div className={cl.header}>
				<SegmentedControl
					className={cl.tabs}
					size="sm"
					options={pickupViewOptions}
					value={selectedView}
					onChange={value => handleViewChange(value as ShopsView)}
				/>
			</div>

			{showList && (
				<ShopsList
					shops={shops}
					activeValue={selectedShop?.name}
					onSelect={handleShopSelection}
					hideRadio={inProduct}
				/>
			)}

			{showMap && (
				<section className={cl.mapBody}>
					<div className={cl.map} datatype="map">
						<ShopsMap shops={shops} activeShopID={selectedShop?.storeId} onSelect={handleShopSelection} />
						{!selectedShop && (
							<Notification type="warning" message="Для перехода к способу оплаты нужно выбрать магазин" />
						)}
					</div>
				</section>
			)}
		</div>
	)
}
